<div class="space-y-3">
	@if (loading) {
	<div class="flex items-center justify-center py-4">
		<div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
		<span class="ml-2 text-sm text-gray-600">Chargement des réponses...</span>
	</div>
	} @else if (responses.length === 0) {
	<div class="text-center py-4 text-gray-500">
		<p class="text-sm">Aucune réponse pour le moment</p>
	</div>
	} @else { @for (response of responses; track response.id) {
	<div class="flex" [class.justify-end]="isOwnMessage(response)" [class.justify-start]="!isOwnMessage(response)">
		<div class="bg-white w-4/5 rounded-lg p-3 border border-gray-200" [class.ml-auto]="isOwnMessage(response)"
			[class.mr-auto]="!isOwnMessage(response)">
			<div class="flex items-start gap-3">
				<div class="flex-1">
					<div class="flex items-center gap-2 mb-1">
						<span class="text-xs text-gray-500">{{
							formatTimestamp(response.createdAt)
							}}</span>
					</div>
					<p class="text-sm text-gray-700">{{ response.content }}</p>
					<!-- @if (response.document) {
					<div class="mt-2">
						<p class="text-xs text-gray-500 mb-1">Document joint :</p>
						<div class="flex items-center gap-2">
							<button (click)="openDocument(response.document)"
								class="text-xs text-primary hover:text-primary/80 underline flex items-center gap-1">
								<svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
										d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
									</path>
								</svg>
								{{ response.document.filename }}
							</button>
							<span class="text-xs text-gray-400">({{ formatFileSize(response.document.sizeBytes) }})</span>
						</div>
					</div>
					} -->
				</div>
				@if (!response.isRead) {
				<div class="w-2 h-2 bg-blue-500 rounded-full"></div>
				}
			</div>
		</div>
	</div>
	} }
</div>